// Module
var code = "<h1 id=\"私有比特资产\">私有比特资产</h1> <p>通过私有比特资产，某些用户可以发行市场锚地资产，然后并不依赖见证人发布的喂价信息。相反的，在创建<em>私有比特资产</em>时，发行人设定一组授权账号来发布喂价信息。发行人可以设置与该资产相关的各种费率参数。</p> <p>这个特性主要适用于一些中心化交易所和机构，它们往往能够获得实时的价格信息，并以此来增加交易量。</p> ";
// Exports
export default code;